<template>
  <form @submit="$emit('submit')">
    <slot />
  </form>
</template>

<script>
export default {
  emits: ["submit", "update:modelValue"],
  props: {
    modelValue: Boolean,
  },
  data() {
    return {
      inputs: [],
      errorBag: new Map(),
      hasErrors: false,
    };
  },
  provide() {
    return {
      form: this,
    };
  },
  methods: {
    validate() {
      return this.inputs.filter((input) => !input.validate(true)).length === 0;
    },
    resetValidation() {},
    reset() {
      this.inputs.forEach((input) => input.reset());
    },
    register(input) {
      this.inputs.push(input);
      input.$watch(
        "hasError",
        (val) => {
          this.errorBag.set(input, val);
          this.updateErrorStatus();
        },
        { immediate: true },
      );
    },
    unregister(input) {
      this.inputs = this.inputs.filter((i) => i !== input);
      this.errorBag.delete(input);
      this.updateErrorStatus();
    },
    updateErrorStatus() {
      const errors = Array.from(this.errorBag.values()).includes(true);
      this.hasErrors = errors;
      this.$emit("update:modelValue", !errors);
    },
  },
};
</script>
